import Vue from 'vue';
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        pdfUrl: "",
    },
    mutations: {
        clearPdfUrl(state) {
            state.pdfUrl = "";
        },
        setrPdfUrl (state, pdfUrl) {
            state.pdfUrl = pdfUrl;
        },
        
    },
    actions: {
    },
    modules: {
    },
    plugins: [createPersistedState()],
})


// WEBPACK FOOTER //
// ./src/store/index.js